const colors = require('tailwindcss/colors')
const plugin = require('tailwindcss/plugin')

module.exports = {
  content: [
    './src/pages/**/*.{js,ts,jsx,tsx}',
    './src/components/**/*.{js,ts,jsx,tsx}'
  ],
  theme: {
    colors: {
      'v2-eerie-black': '#191818',
      'v2-teks-3': '#898998',
      'v2-gray-x11': '#BABABA',
      'v2-sonic-silver': '#717171',
      'v2-bleu-de-france': '#4689D9',
      indigo: {
        50: '#eef2ff'
      },
      orange: {
        light: '#f9ad36',
        DEFAULT: '#ff9c00',
        dark: '#ff8a00',
        new: '#FFBA33'
      },
      white: {
        light: '#f5f5f5',
        DEFAULT: '#ffffff',
        dark: '#F3F4F6'
      },
      cyan: '#5ccbe1',
      purple: '#2f1396',
      green: '#3ccc00',
      yellow: {
        light: '#FFDEAB',
        DEFAULT: '#ffde34'
      },
      blue: {
        light: '#15C9E5',
        DEFAULT: '#0088ff'
      },
      softBlue: '#5875d1',
      black: '#000000',
      softBlack: '#13132C',
      gray: {
        40: '#FAFAFA',
        50: '#f3f3f3',
        100: '#e6e6e6',
        200: '#cccccc',
        250: '#c4c4c480',
        300: '#b3b3b3',
        400: '#999999',
        500: '#808080',
        600: '#666666',
        700: '#4d4d4d',
        800: '#333333',
        900: '#1a1a1a'
      },
      red: colors.rose,
      pink: colors.fuchsia,
      transparent: 'transparent',
      v3: {
        gray: {
          50: '#F2F2F2',
          75: '#F4F4F4',
          100: '#D5D5D5',
          150: '#D9D9D9',
          200: '#ACACAC',
          250: '#BABABA',
          275: '#939393',
          300: '#828282',
          400: '#595959',
          425: '#5C5C5C',
          450: '#474747',
          475: '#565656',
          500: '#2F2F2F',
          600: '#262626',
          700: '#212427',
          900: '#0F0F0F'
        },
        orange: {
          100: '#FFE49E',
          300: '#FFCB66',
          325: '#FFC852',
          350: '#FFC25F',
          375: '#FFBA49',
          400: '#FFBA33',
          500: '#FF9C00',
          550: '#F49600',
          600: '#CC7D00'
        },
        red: {
          400: '#DB3333'
        }
      }
    },
    fontFamily: {
      noto: ['Noto Sans', 'sans-serif'],
      sans: ['Roboto', 'sans-serif'],
      myriad: ['Myriad Pro', 'sans-serif'],
      serif: ['Chivo', 'serif'],
      fira: ['Fira Sans', 'sans-serif'],
      robotoSlab: ['Roboto Slab', 'sans-serif'],
      notoSerif: ['Noto Serif', 'sans-serif'],
      chivo: ['Chivo', 'sans-serif'],
      roboto: ['Roboto', 'sans-serif'],
      segoe: ['Segoe UI', 'sans-serif'],
      workSans: ['Work Sans', 'sans-serif'],
      commissioner: ['Commissioner', 'sans-serif']
    },
    extend: {
      spacing: {
        1: '4px',
        2: '8px',
        3: '12px',
        4: '16px',
        5: '20px',
        6: '24px',
        7: '28px',
        8: '32px',
        82: '21rem'
      },
      maxWidth: {
        'screen-2xl': '90rem'
      },
      borderRadius: {
        '4xl': '2rem'
      },
      lineHeight: {
        9.5: '2.375rem',
        11: '2.75rem',
        12: '3rem'
      },
      fontSize: {
        '3.2xl': '2rem',
        '4.5xl': '2.5rem'
      },
      boxShadow: {
        DEFAULT:
          '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 0 0 0.2rem rgb(0 123 255 / 25%)'
      },
      colors: {
        primary: '#ff9c00',
        red: '#ec2000',
        green: '#08cc2f'
      },
      backgroundImage: {
        'gradient-simulation-banner-mobile':
          'linear-gradient(180deg, rgba(0, 0, 0, 0) 23.96%, rgba(0, 0, 0, 0.6) 67.19%)',
        'gradient-calculator-solar-title':
          'linear-gradient(270deg, #FF9C00 0%, #FFC25F 100%)'
      },
      dropShadow: {
        glow: [
          '0 0px 20px rgba(255,255, 255, 0.35)',
          '0 0px 65px rgba(255, 255,255, 0.2)'
        ]
      },
      gridTemplateColumns: {
        'multi-step-franchise-form': '1fr 0.625rem 1fr'
      },
      screens: {
        '1.5xl': '1440px'
        // => @media (min-width: 1440px) { ... }
      },
      transitionProperty: {
        'height': 'height',
        'max-height': 'max-height',
      }
    }
  },
  plugins: [
    plugin(function ({ addBase }) {
      addBase({
        '@font-face': {
            fontFamily: 'Myriad Pro',
            fontWeight: '300',
            fontDisplay: 'swap',
            src: 'url(/fonts/MYRIADPRO-LIGHT.ttf)'
        }
      }),
        addBase({
          '@font-face': {
            fontFamily: 'Myriad Pro',
            fontWeight: '400',
            fontDisplay: 'swap',
            src: 'url(/fonts/MYRIADPRO-REGULAR.OTF)'
          }
        }),
        addBase({
          '@font-face': {
            fontFamily: 'Myriad Pro',
            fontWeight: '600',
            fontDisplay: 'swap',
            src: 'url(/fonts/MYRIADPRO-SEMIBOLD.OTF)'
          }
        }),
        addBase({
          '@font-face': {
            fontFamily: 'Myriad Pro',
            fontWeight: '700',
            fontDisplay: 'swap',
            src: 'url(/fonts/MYRIADPRO-BOLD.OTF)'
          }
        }),
        addBase({
          '@font-face': {
            fontFamily: 'Myriad Pro',
            fontWeight: '900',
            fontDisplay: 'swap',
            src: 'url(/fonts/MYRIADPRO-BLACK.ttf)'
          }
        })
    })
  ]
}
